import { SMSTag, Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';

export const dedupeThreadTags = (thread: Thread): Thread => ({
  ...thread,
  uniqueTags: thread.uniqueTags ? dedupeSMSTagsArray(thread.uniqueTags) : undefined,
});

export const dedupeSMSTagsArray = (tags: SMSTag[]): SMSTag[] => {
  const tagsObj: Record<string, SMSTag> = {};
  tags.forEach((tag) => {
    const existingTag = tagsObj[tag.tagId];
    if (!existingTag) {
      tagsObj[tag.tagId] = tag;
    } else {
      const isNewerThanExisting = tag.smsCreatedAt > existingTag.smsCreatedAt;
      if (isNewerThanExisting) {
        tagsObj[tag.tagId] = tag;
      }
    }
  });

  return Object.values(tagsObj).sort((a, b) =>
    a.smsCreatedAt > b.smsCreatedAt ? -1 : a.smsCreatedAt < b.smsCreatedAt ? 1 : 0
  );
};
